export default axiosInstance => {
  async function create({ jwt, type, content }) {
    return axiosInstance({
      method: "post",
      url: "/liff/feedback",
      headers: { jwt },
      data: { type, content }
    });
  }

  return {
    create
  };
};
